module.exports = __webpack_public_path__ + "03_medium_black.e3d4bf33.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_medium_black.png
// module id = ybxO
// module chunks = 0